module.exports = __webpack_public_path__ + "img/HZ-T1326.368b2f16.jpg";